import React, { useMemo } from 'react'
import { TodoTask } from './todo-task'
import { TodoTypes } from './todo.types'

export type TodoTasks = {
    parentColor?: string
    tasks: TodoTypes.Task[]
    visible: boolean
    freeze: boolean
    indent?: number
    parentSelected?: boolean
}

export const TodoTasks = (props: TodoTasks) => {
    const { visible = true, freeze, indent = 0, parentSelected = false } = props
    const tasks = useMemo(() => props.tasks ?? [], [props.tasks])

    return (
        <>
            {tasks.map((task: any, index: number) => (
                <TodoTask
                    key={task.id}
                    task={task}
                    visible={visible}
                    freeze={freeze}
                    indent={indent}
                    parentSelected={parentSelected}
                />
            ))}
        </>
    )
}
